import React from 'react';
import './Home.scss';
import SocialMedia from './SocialMedia';
import Decorations from './decorations';

class Home extends React.Component {

  render() {
    return (
      <div className="home">
        <div >
          <iframe className="Embed-youtube" ref={this.youtube} width="560" title="Trailer La Isla B" height="350" src="https://www.youtube.com/embed/D84pfA47lbk" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        </div>
        <div className="home-footer">
          <SocialMedia/>
        </div>
          <Decorations/>
      </div>
    );
  }
}

export default Home;
